import React from 'react'
import Tags from '../tags'

const TemplateTitle = ({ item, className = '', children }) => {
  let labelText = 'Premium'
  let labelStyles = 'bg-blue-500'

  if (item.isArchived) {
    labelStyles = 'bg-gray-500'
    labelText = 'Archived'
  } else if (item.isFree) {
    labelStyles = 'bg-black'
    labelText = 'Free'
  }

  return (
    <div className={`text-center ${className}`}>
      
      <div className="flex space-x-2 items-center justify-center tracking-widest uppercase leading-tight mb-1.5">
        <p>
          <span className={`inline-block rounded text-white px-2 py-1 ${labelStyles}`}>
            {labelText}
          </span>
        </p>
        {item.name && <p>{item.name}</p>}
      </div>
      <h1 className="text-4xl font-black leading-tight">{item.tech ?? item.title}</h1>
      {!!item.updated && (

        <h3 className='mb-3 mt-5 uppercase text-sm flex items-center justify-center'>
          <span className='inline-flex py-0.5 px-3 bg-gray-100 text-gray-600 rounded-l-sm'>Updated</span>
          <span className='inline-flex py-0.5 px-3 bg-gray-200 text-gray-800 rounded-r-sm font-semibold'>{item.updated}</span>
        </h3>
      )}
      <h2 className="text-xl leading-tight mb-12 mt-6">
        {item.subtitle}
        <br />
        {item.subtitle2}
      </h2>
      
      <Tags tags={item.tags} justify="justify-center" style="blackOutline" size="sm" />
      {children}
    </div>
  )
}

export default TemplateTitle
